import React, { useEffect, useState } from "react";

import { Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";

import {
  fetchCompanies,
  hideModal,
  ICompany,
  selectCompany,
  selectDisplayModal,
  updateCompany,
} from "../../features/company/companySlice";
import { fetchPrograms } from "../../features/program/programSlice";
import { AfterActions, DialogPopUp } from "../common/DialogPopUp";
import { MainLayout } from "../common/Layouts/Main";
import { CompanyForm } from "./Form";
import LoadingOverlay from "../common/LoadingOverlay";
import { ActionSuffixes, Prefixes } from "../prefixes";
import { FormFooter } from "../common/FormFooter";
import { getTranslations } from "../../features/translations/translationsUtils";
import { fetchLanguages } from "../../features/languages/languagesSlice";

export const EditCompany: React.FunctionComponent = () => {
  const [loaded, setLoaded] = useState<boolean>(false);
  const match = useRouteMatch();
  const [newCompany, setNewCompany] = useState<ICompany>();
  const [currentAction, setCurrentAction] = useState<string>("");
  const history = useHistory();
  const isModalVisible = useSelector(selectDisplayModal);
  const selectedCompany = useSelector(selectCompany((match.params as any).id!));
  const dispatch = useDispatch();

  useEffect(() => {
    if ((!newCompany && selectedCompany) || (newCompany && selectedCompany && newCompany._id !== selectedCompany._id)) {
      setNewCompany(selectedCompany);
      setLoaded(true);
    }
  }, [selectedCompany, newCompany]);

  useEffect(() => {
    dispatch(fetchCompanies());
    dispatch(fetchPrograms());
    dispatch(fetchLanguages());
  }, [dispatch]);

  const [form] = Form.useForm();

  if (!loaded) {
    return <LoadingOverlay spinning={true} />;
  }

  return (
    <MainLayout
      title={getTranslations('COMPANY_EDIT')}
      onGoBack={() => {
        history.push(`${Prefixes.company}`);
      }}
      breadcrumbs={[getTranslations('COMPANY_TITLE'), getTranslations('COMPANY_EDIT')]}
    >
      <DialogPopUp
        name={getTranslations('LIST_COMPANY')}
        action={getTranslations('COMPANY_UPDATED')}
        visible={isModalVisible}
        onCancel={() => {
          dispatch(hideModal());
          if (currentAction === AfterActions.BACK) {
            history.push(`${Prefixes.company}`);
          } else {
            history.push(`${Prefixes.company}${ActionSuffixes.new}`);
          }
        }}
      />
      <div>
        <CompanyForm
          form={form}
          newCompany={newCompany}
          setNewCompany={setNewCompany}
        />
      </div>
      <FormFooter
        editing
        objectName={getTranslations('COMPANY_EDIT_SINGULAR').toLocaleLowerCase()}
        onCancel={() => {
          history.push(`${Prefixes.company}`);
        }}
        onSave={() => {
          form
            .validateFields()
            .then((_value) => {
              if (!newCompany) {
                return;
              }
              setCurrentAction(AfterActions.BACK);
              dispatch(updateCompany({ language: 'es', ...newCompany }));
            })
            .catch((error) => {
              console.error(
                "Company:React.FunctionComponent -> error",
                error
              );
            });
        }}
        onSaveAndCreateAnother={() => {
          form
            .validateFields()
            .then((_value) => {
              if (!newCompany) {
                return;
              }
              setCurrentAction(AfterActions.STAY);
              dispatch(updateCompany({ language: 'es', ...newCompany }));
            })
            .catch((error) => {
              console.error(
                "Company:React.FunctionComponent -> error",
                error
              );
            });
        }}
      />
    </MainLayout>
  );
};
